<template>
	<sui-form @submit.prevent>
		<sui-form-field>
			<label v-if="!sinTitulo" :class="[$style.titulo, $style.boldFont]">{{
				titulo
			}}</label>
			<textarea
				:value="value"
				:rows="rows"
				:placeholder="placeholder"
				:maxlength="maxlength"
				:disabled="disabled"
				@input="$emit('input', $event.target.value)"
			/>
			<div style="margin-top: 5px;">
				<span v-show="error" :class="$style.danger">
					<sui-icon name="exclamation circle" />
					{{ mensajeError }}
				</span>
			</div>
		</sui-form-field>
	</sui-form>
</template>

<script>
export default {
	props: {
		disabled: {
			type: Boolean,
			default: false
		},
		placeholder: {
			type: String,
			default: ''
		},
		value: {
			type: [String, Number],
			default: ''
		},
		titulo: {
			type: String,
			default: 'Campo'
		},
		error: {
			type: Boolean,
			default: false
		},
		mensajeError: {
			type: String,
			default: 'Dato obligatorio'
		},
		maxlength: {
			type: [String, Number],
			default: ''
		},
		sinTitulo: {
			type: Boolean,
			default: false
		},
		rows: {
			type: [String, Number],
			default: 4
		}
	},
	methods: {
		onInput(value) {
			this.$emit('input', value);
		}
	}
};
</script>

<style lang="scss" module>
@import '@design';
.titulo {
	font-size: 14px !important;
	color: #5c5d5d !important;
}
.danger {
	color: #9f2241 !important;
}
</style>
